export default {
  abilityToInvoice: 'számlaképesség',
  address: 'cím',
  agreePrivacyPolicy: 'adatvédelmi tájékoztató',
  agreeTermsOfService: 'felhasználási feltételek',
  birthDate: 'születési idő',
  citizenship: 'állampolgárság',
  companyName: 'cégnév',
  contactName: 'kapcsolattartó nevének',
  contactEmail: 'kapcsolattartó e-mail címének',
  contactPhone: 'kapcsolattartó telefonszámának',
  confirmPassword: 'jelszó megismétlése',
  cv: 'önéletrajz',
  date: 'dátum',
  drivingLicence: 'vezetői engedély',
  email: 'e-mail cím',
  firstName: 'vezetéknév',
  from: 'mettől',
  gender: 'nem',
  invCity: 'város',
  invCountry: 'ország',
  invEmail: 'e-mail cím',
  invName: 'számlázási név',
  invPostalCode: 'irányítószám',
  invRoute: 'utca',
  invStreetNumber: 'házszám',
  invTaxNumber: 'adószám',
  isAdwatchActive: 'hirdetésfigyelő',
  lastName: 'keresztnév',
  method: 'fizetési mód',
  minNettoWanted: 'fizetési igény',
  occupation: 'munkakör',
  occupationDescription: 'munkakör leírás',
  otherLegalRelationship: 'egyéb adatok',
  password: 'jelszó',
  payPlanId: 'ajánlati kártya csomag',
  picture: 'fénykép',
  picturePolicy: 'fénykép szabályozás',
  phone: 'telefonszám',
  reason: 'indok',
  references: 'korábbi munkahelyek, tapasztalatok, referenciák',
  referencesPolicy: 'referencia szabályozás',
  replytoName: 'válasz címzett neve',
  replytoEmail: 'válasz címzett e-mail címe',
  senderEmail: 'feladó e-mail cím',
  senderName: 'feladó neve',
  subject: 'tárgy',
  to: 'meddig',
  toEmail: 'előnézeti e-mail cím',
  toggleDistricts: 'munkavállalási hely',
  'skills[it]': 'számítástechnikai ismeretek',
  quantity: 'mennyiség',
  willingToTrain: 'átképzés, betanulás',
  workDays: 'munkavállalási napok',
  workHome: 'otthoni munkavégzés',
  workHoursPerDay: 'napi munkaidő',
  workLoc: 'munkavégzési hely',
  workWholeCountry: 'munkavállalási hely',
  workTimeOfDay: 'napszakok'
}



// WEBPACK FOOTER //
// ./src/locales/hu/attributes.js